import InfoRail from './InfoRail';

export default InfoRail;
